import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { computed } from "@vue/composition-api";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
export const useFillOutVisibility = () => {
  const {
    HAS_CONSOLIDATED_REQUEST,
    PAGES_TO_FILL_OUT,
    MORTGAGE_DETAILS_REQUESTED,
    PROPERTY_REQUESTED
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST, ApplicationStandaloneGetters.PAGES_TO_FILL_OUT, ApplicationStandaloneGetters.MORTGAGE_DETAILS_REQUESTED, ApplicationStandaloneGetters.PROPERTY_REQUESTED]);
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const computeFillOutVisibility = (page, options = {}) => {
    return computed(() => {
      var _context;
      if (!HAS_CONSOLIDATED_REQUEST.value) return true;
      if (_includesInstanceProperty(_context = PAGES_TO_FILL_OUT.value).call(_context, page)) {
        switch (page) {
          case APPLICATION_STEPS.APPLICANTS:
          case APPLICATION_STEPS.IDENTIFICATIONS:
          case APPLICATION_STEPS.INCOME_HISTORY:
          case APPLICATION_STEPS.ASSETS:
          case APPLICATION_STEPS.LIABILITIES:
          case APPLICATION_STEPS.OTHER_PROPERTIES:
            return isApplicantVisibleFromFillOut(options.applicantId);
          case APPLICATION_STEPS.GOALS:
            if (options.path) {
              var _context2, _context3;
              const isMortgageDetails = _includesInstanceProperty(_context2 = options.path).call(_context2, "mortgage-details");
              const isProperty = _includesInstanceProperty(_context3 = options.path).call(_context3, "property");
              return MORTGAGE_DETAILS_REQUESTED.value && isMortgageDetails || PROPERTY_REQUESTED.value && isProperty;
            }
        }
      }
      return false;
    });
  };
  return {
    computeFillOutVisibility
  };
};